import React from "react";
import { Col } from "react-bootstrap";
import CategoryCompaniesCard from "@/components/companyCard";

export default function FavouritesCard(props) {
  const companies = props.companies;
  console.log("com", companies);
  return (
    <div className="d-flex flex-row flex-wrap">
      {companies.length > 0 &&
        companies.map((company) => <Col
        md={6}
        sm={6}
        lg={4}
        xl={3}
        xs={12}
        className="p-3 "
        key={company.slug}
      >
        <CategoryCompaniesCard
          company={company}
        />
      </Col>)}
    </div>
  );
}
